import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import encryptStorage from '../utils/encryptStorage';
import envConfig from '../configs/env';

const { persistAtom } = recoilPersist({
  key: '@persist-store',
  storage: envConfig.stage === 'production' ? encryptStorage() : localStorage,
});

const accessTokenAtom = atom({
  key: 'accessToken',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

const userAtom = atom({
  key: 'user',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

const permissionAtom = atom({
  key: 'permission',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export { accessTokenAtom, userAtom, permissionAtom };
